<section class="reset-section">
  <div class="container">
    <div class="reset-container">
      <div class="reset-card">
        <div class="reset-header">
          <h1 class="reset-title">
            {{ !hasCode ? ("page.login.resetPassword" | translate) : ("page.reset-password.title" | translate) }}
          </h1>
          <p class="reset-subtitle">
            {{ !hasCode ? ("page.reset-password.emailDescription" | translate) : ("page.reset-password.codeDescription" | translate) }}
          </p>
        </div>

        <!-- Error Alerts -->
        <div class="error-alert" *ngIf="!hasCode && isEmailError">
          <span class="error-icon">⚠️</span>
          <span>{{ "page.reset-password.emailError" | translate }}</span>
        </div>
        <div class="error-alert" *ngIf="hasCode && isCodeError">
          <span class="error-icon">⚠️</span>
          <span>{{ "page.reset-password.codeError" | translate }}</span>
        </div>

        <form [formGroup]="emailForm" (ngSubmit)="onSubmit()" class="email-form" *ngIf="!hasCode">
          <!-- Email field -->
          <div class="form-group">
            <label for="email" class="form-label">{{ "form.email" | translate }}</label>
            <input type="email" id="email" formControlName="email" class="form-input" maxlength="255" />
            <div class="error-message" *ngIf="emailForm.controls.email.touched && emailForm.controls.email.errors?.['required']">
              <span>{{ "page.login.error.required" | translate }} </span>
            </div>
            <div class="error-message" *ngIf="emailForm.controls.email.touched && emailForm.controls.email.errors?.['pattern']">
              <span>{{ "page.login.error.email" | translate }} </span>
            </div>
          </div>

          <div class="form-buttons">
            <button type="button" class="button color-gray" (click)="goBack()">
              {{ "button.cancel" | translate }}
            </button>
            <button type="submit" class="button color-blue" [disabled]="emailForm.disabled">
              {{ "button.send" | translate }}
            </button>
          </div>
        </form>
        <form [formGroup]="codeForm" (ngSubmit)="onSubmit()" class="email-form" *ngIf="hasCode">
          <!-- Code field -->
          <div class="form-group">
            <label for="code" class="form-label">{{ "form.code" | translate }}</label>
            <input type="text" id="code" formControlName="code" class="form-input" />
          </div>
          <!-- New password field -->
          <div class="form-group">
            <label for="password" class="form-label">{{ "form.password" | translate }}</label>
            <div class="password-input-wrapper">
              <input
                [type]="showPassword ? 'text' : 'password'"
                id="password"
                formControlName="password"
                class="form-input"
                autocomplete="new-password"
                maxlength="255"
              />
              <button type="button" class="password-toggle" (click)="showPassword = !showPassword" tabindex="-1">
                {{ showPassword ? "👁️" : "👁️‍🗨️" }}
              </button>
            </div>
            <div class="error-message" *ngIf="codeForm.controls.password.touched && codeForm.controls.password.errors?.['required']">
              <span>{{ "page.login.error.required" | translate }} </span>
            </div>
            <div class="error-message" *ngIf="codeForm.controls.password.touched && codeForm.controls.password.errors?.['pattern']">
              <span>{{ "page.login.error.password" | translate }} </span>
            </div>
          </div>
          <!-- Confirm new password field -->
          <div class="form-group">
            <label for="confirmPassword" class="form-label">{{ "form.confirmPassword" | translate }}</label>
            <div class="password-input-wrapper">
              <input
                [type]="showConfirmPassword ? 'text' : 'password'"
                id="confirmPassword"
                formControlName="confirmPassword"
                class="form-input"
                autocomplete="new-password"
                maxlength="255"
              />
              <button type="button" class="password-toggle" (click)="showConfirmPassword = !showConfirmPassword" tabindex="-1">
                {{ showConfirmPassword ? "👁️" : "👁️‍🗨️" }}
              </button>
            </div>
            <div
              class="error-message"
              *ngIf="codeForm.controls.confirmPassword.touched && codeForm.controls.confirmPassword.errors?.['matching']"
            >
              <span>{{ "page.login.error.confirmPassword" | translate }} </span>
            </div>
          </div>

          <div class="form-buttons">
            <button type="button" class="button color-gray" (click)="hasCode = !hasCode">
              {{ "button.back" | translate }}
            </button>
            <button type="submit" class="button color-blue" [disabled]="codeForm.disabled">
              {{ "button.confirm" | translate }}
            </button>
          </div>
        </form>

        <div class="already-have-link" *ngIf="!hasCode">
          <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -->
          <a class="already-have" tabindex="0" (click)="hasCode = !hasCode">
            {{ "page.reset-password.alreadyHave" | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
